import LeftMenuDrawer from './LeftMenuDrawer';
import React from 'react';

const Drawers = () => {
  return (
    <div>
      <LeftMenuDrawer />
    </div>
  );
};

export default Drawers;
